import IMAGES from "@/public/assets/img";



export const customPagesContent = {
  KeyFeaturesLoan :[
    {
      id: 1,
      image: IMAGES.businessLoan?.trueLogoLoan,
      heading: "Collateral-Free Funding ",
      description: "Secure capital without risking personal or business assets",
    },
    {
      id: 2,
      image: IMAGES.businessLoan?.trueLogoLoan,
      heading: "Seamless Digital Journey",
      description: "Paperless applications, instant approvals and funds transferred with just a few clicks",
    },
    {
      id: 3,
      image: IMAGES.businessLoan?.trueLogoLoan,
      heading: "Tailored Repayment Solutions",
      description: "Align repayments with your cash flow for stress-free financial management",
    },
    {
      id: 4,
      image: IMAGES.businessLoan?.trueLogoLoan,
      heading: "Lightning-Fast Approval",
      description: "Receive a lending decision within 48 hours, accelerating access to critical funds",
    },
],
KeyFeaturesExportFact :[
    {
      id: 1,
      image: IMAGES.businessLoan?.trueLogoLoan,
      heading: "Instant Cash Flow",
      description: "Receive payment in 24–48 hours, freeing up working capital",
    },
    {
      id: 2,
      image: IMAGES.businessLoan?.trueLogoLoan,
      heading: "No Collateral Needed",
      description: "Invoice-based funding means no need to pledge assets",
    },
    {
      id: 3,
      image: IMAGES.businessLoan?.trueLogoLoan,
      heading: "Credit Risk Protection",
      description: "Credlix screens buyers and can cover against non-payment",
    },
    {
      id: 4,
      image: IMAGES.businessLoan?.trueLogoLoan,
      heading: "Scalable & Flexible",
      description: "Choose which invoices to factor—grow at your pace.",
    },
    {
      id: 5,
      image: IMAGES.businessLoan?.trueLogoLoan,
      heading: "Fully Digital",
      description: "End-to-end online processing with minimal documentation.",
    },
    {
      id: 6,
      image: IMAGES.businessLoan?.trueLogoLoan,
      heading: "Free Buyer Verification",
      description: "Ensure you work with creditworthy international buyers.",
    },
],
KeyFeaturesOtherPages:[
    {
      id: 1,
      image: IMAGES.businessLoan?.trueLogoLoan,
      heading: "Unlock Growth with Zero Collateral",
      description: "Fuel your business without asset-backed stress—get easy access to unsecured working capital.",
    },
    {
      id: 2,
      image: IMAGES.businessLoan?.trueLogoLoan,
      heading: "Smart Pricing, Zero Surprises",
      description: "Access capital at attractive rates with full transparency and no hidden charges.",
    },
    {
      id: 3,
      image: IMAGES.businessLoan?.trueLogoLoan,
      heading: "Repayment Terms that Work for You",
      description: "Choose loan tenures and schedules aligned with your business cash flows and cycles.",
    },
    {
      id: 4,
      image: IMAGES.businessLoan?.trueLogoLoan,
      heading: "Onboard Once to Enable End-to-End Digital Processing",
      description: "Experience end-to-end digital credit access with a single setup process.",
    },
],
eligibilityPoints :[
    {
      id: 1,
      heading: "Eligible Business Entities and Sectors",
      description: "Self-employed professionals, sole proprietorships, private limited companies, partnership firms and Limited Liability Partnership firms engaged in manufacturing, trading, or service-oriented industries are eligible to apply. ",
    },
    {
      id: 2,
      heading: "Annual Turnover Requirement",
      description: "The business must report a minimum annual turnover of ₹50 lakhs (INR 50,00,000) as per the latest financial records.",
    },
    {
      id: 3,
      heading: "Minimum Business Operational Tenure",
      description: "Applicants must have a minimum operational history of one (1) year in their current business at the time of application.",
    },
    {
      id: 4,
      heading: "Applicant Age Parameters",
      description: "The applicant must be at least 21 years old when submitting the loan application and must not exceed 65 years of age by the loan’s maturity date.",
    },
],
eligibilityPointsExport :[
    {
      id: 1,
      heading: "You're an Exporter Selling on Credit",
      description: "You send goods overseas and your buyers pay at a later date",
    },
    {
      id: 2,
      heading: "You Have a Good Export Track Record",
      description: "You’ve been selling regularly to buyers in countries like the US, UK, EU, Mexico, Brazil, etc. ",
    },
    {
      id: 3,
      heading: "Your Business Exports over ₹5 Crore a Year",
      description: "Your total yearly exports across all countries and buyers are more than ₹5 crore ",
    },
    {
      id: 4,
      heading: "Applicant Age Parameters",
      description: "The applicant must be at least 21 years old when submitting the loan application and must not exceed 65 years of age by the loan’s maturity date.",
    },
],
eligibilityPointsOthers :[
    {
      id: 1,
      heading: "Minimum Turnover",
      description: "₹10 Crore and above ",
    },
    {
      id: 2,
      heading: "Eligible Sectors",
      description: "Manufacturing, Trading, or Services ",
    },
    {
      id: 3,
      heading: "Business Vintage",
      description: "Minimum of 3 years in operation ",
    },
    {
      id: 4,
      heading: "Operational Location",
      description: "Entities based in Tier 1 and Tier 2 cities",
    },
    {
      id: 5,
      heading: "CIBIL Score Requirement",
      description: "700 or above ",
    },
],
identityDocuments :{
  documents:[
    {id: 1, heading: "PAN Card"},
    {id: 2, heading: "Voter's ID Card"},
    {id: 3, heading: "GST Certificate"},
    {id: 4, heading: "Driving License"},
    {id: 5, heading: "Passport"},
    {id: 6, heading: "Ownership Proof"},
    {id: 7, heading: "Aadhar Card"},
    {id: 8, heading: "Bank Statement for 12 months"},
    {id: 9, heading: "Udhyam Registration Certificate"},

],
roi:{
  text:'Starting at just <strong> 1.5% Per Month</strong>'
}},
identityDocumentsExport :{
   documents:[
    {id: 1, heading: "KYC of Exporting Entity "},
    {id: 2, heading: "Trade ledger with buyers "},
    {id: 3, heading: "Trade ledger with buyers "},
    {id: 4, heading: "Sample transaction documents"},
    // {id: 5, heading: "Passport"},
    // {id: 6, heading: "Ownership Proof"},
    // {id: 7, heading: "Aadhar Card"},
    // {id: 8, heading: "Bank Statement for 12 months"},
    // {id: 9, heading: "Udhyam Registration Certificate"},
],
roi:{
  text:'*Get  <strong>up to 90 %</strong> of invoice value upfront.'
}
} ,
identityDocumentsOther :{
   documents:[
    {id: 1, heading: "PAN Card"},
    {id: 2, heading: "Voter's ID Card"},
    {id: 3, heading: "GST Certificate"},
    {id: 4, heading: "Driving License"},
    {id: 5, heading: "Passport"},
    {id: 6, heading: "Ownership Proof"},
    {id: 7, heading: "Aadhar Card"},
    {id: 8, heading: "Bank Statement for 12 months"},
    {id: 9, heading: "Udhyam Registration Certificate"},

],
roi:{
  text:'Smart Financing Begins at just <strong> 1% per month* </strong>'
}
} ,
slidesData :[
    {
      id: 1,
      content: "Fastest loan approval I’ve ever seen! Helped me stock up on inventory right before the peak season.",
      name: "Founder – Wholesale Electronics Trader – Delhi",
      position: "",
    },
    {
      id: 2,
      content: "Credlix’s Customer service was top-notch! They explained everything clearly and got me the best deal possible.",
      name: "Proprietor – Textile Manufacturer – Surat",
      position: "",
    },
    {
      id: 3,
      content: "This loan helped me fulfill bulk export orders on time. Flexible terms made repayment easy & there were No hidden charges, smooth process, and quick disbursal.",
      name: "Founder – Leather Goods Manufacturer – Kanpur",
      position: "",
    },
    {
      id: 4,
      content: "Expanding my supply network seemed tough, but Credlix's hassle-free loan process made it possible!",
      name: "Director – FMCG Distributor – Kolkata",
      position: "",
    },
  ]

};